// v10/src/mock/aircraftData.js - UPDATED
export const aircraftModels = [  
  {  
    id: 'piper-pa28',  
    name: 'Piper PA-28 Warrior',  
    checklist: [  
      {  
        section: 'Sección Fluidos',  
        items: [  
          {
            text: 'Drenaje de tanques de combustible',
            referenceImage: '/images/reference/piper-pa28/nose-drain.png', 
            description: 'Drenar agua y sedimentos del tanque de combustible usando el drenaje inferior'
          },
          {
            text: 'Drenaje de filtro nariz de combustible',
            referenceImage: '/images/reference/piper-pa28/fuel-drain.jpg', 
            description: 'Verificar el filtro de combustible en la nariz del avión'
          },
          {
            text: 'Combustible tanque izquierdo',
            referenceImage: '/images/reference/piper-pa28/fuel-drain.jpg',
            description: 'Verificar nivel y calidad del combustible en tanque izquierdo',
            suggestion: {
              text: '⛽ Recordá que este avión consume aproximadamente 30 litros de combustible por hora de vuelo.',
              detail: 'Asegurate de tener suficiente para el vuelo + reserva mínima de 45 minutos.'
            }
          },
          {
            text: 'Combustible tanque derecho',
            referenceImage: null,
            description: 'Verificar nivel y calidad del combustible en tanque derecho'
          },
          {
            text: 'Tapa de tanque ajustar sin apretar',
            referenceImage: null,
            description: 'Asegurar que las tapas estén bien cerradas pero no sobre-apretadas'
          },
          {
            text: 'Chequear aceite entre 6 - 8 cuartos',
            referenceImage: '/images/reference/piper-pa28/fuel-drain.jpg',
            description: 'Verificar nivel de aceite del motor usando la varilla',
            suggestion: {
              text: '🛢️ Recordá mantener el nivel de aceite entre 6 y 8 cuartos para un funcionamiento óptimo del motor.',
              detail: 'Nunca vueles con menos de 6 cuartos. El consumo normal es 1 cuarto cada 4 horas.'
            }
          },
          {
            text: 'Chequear tapa inspeccion de aceite',
            referenceImage: null,
            description: 'Asegurar que la tapa de inspección esté correctamente cerrada'
          },
          {
            text: 'Chequear nivel liquidos de frenos',
            referenceImage: null,
            description: 'Verificar el nivel del fluido de frenos en el depósito'
          }
        ]  
      },  
      {  
        section: 'Sección Cabina',  
        items: [  
          {
            text: 'Llave a bordo y fuera del arranque',
            referenceImage: null,
            description: 'Verificar que la llave esté insertada pero no en posición de arranque'
          },
          {
            text: 'Registrar horometro',
            referenceImage: null,
            description: 'Anotar las horas de vuelo del horómetro'
          },
          {
            text: 'Controles de vuelo libres',
            referenceImage: null,
            description: 'Mover el yugo y pedales para verificar movimiento libre'
          },
          {
            text: 'Frenos aplicados',
            referenceImage: null,
            description: 'Presionar pedales de freno para verificar funcionamiento'
          },
          {
            text: 'Radio Off',
            referenceImage: null,
            description: 'Asegurar que todos los equipos de radio estén apagados'
          },
          {
            text: 'Avionica/vor/adf/transponder Off',
            referenceImage: null,
            description: 'Verificar que todos los sistemas aviónica estén apagados'
          },
          {
            text: 'Acelerador cerrado',
            referenceImage: null,
            description: 'Verificar que el acelerador esté en posición cerrada'
          },
          {
            text: 'Mezcla cerrada',
            referenceImage: null,
            description: 'Verificar que la mezcla esté en posición cerrada'
          }
        ]  
      }  
    ],  
    suggestions: ['Recordá tener mínimo 30 litros de combustible si vas a volar 1 hora.', 'Verificá el aceite entre 6 y 8 cuartos para un vuelo seguro.']  
  },  
  {  
    id: 'cessna-150',  
    name: 'Cessna 150',  
    checklist: [  
      {  
        section: 'Sección General',  
        items: [  
          {
            text: 'Puerta de cabina abierta',
            referenceImage: null,
            description: 'Abrir completamente la puerta de cabina antes de la inspección'
          },
          {
            text: 'Interruptor maestro apagado',
            referenceImage: null,
            description: 'Verificar que el interruptor maestro esté en posición OFF'
          },
          {
            text: 'Selector de combustible en ambos',
            referenceImage: null,
            description: 'Colocar selector de combustible en posición BOTH'
          },
          {
            text: 'Verificar cantidad de combustible',
            referenceImage: null,
            description: 'Inspección visual del nivel de combustible en ambos tanques'
          },
          {
            text: 'Nivel de aceite adecuado',
            referenceImage: null,
            description: 'Verificar nivel de aceite del motor'
          },
          {
            text: 'Área de hélice despejada',
            referenceImage: null,
            description: 'Verificar que no haya objetos cerca de la hélice'
          },
          {
            text: 'Prueba de advertencia de stall',
            referenceImage: null,
            description: 'Verificar el funcionamiento de la alarma de pérdida'
          }
        ]  
      }  
    ],  
    suggestions: ['Verificá al menos 20 litros de combustible para vuelos cortos de 45 minutos.']  
  }  
];  

export const defaultSession = {  
  date: new Date().toISOString().split('T')[0],  
  time: new Date().toLocaleTimeString(),  
  clubName: '',  
  aircraft: '',  
  completedChecklist: []  
};  

// UPDATED: Wind now in KNOTS and degrees
export const mockWeather = {  
  location: 'Puerto Madryn',  
  temperature: 22,  
  condition: 'Despejado',  
  qnh: 1013,
  qne: 1013,
  windSpeedKts: 12, // in knots (not km/h!)
  windDirectionDeg: 45 // in degrees: 0=North, 90=East, 180=South, 270=West
};
